module.exports = __webpack_public_path__ + "img/computecoin.fd825922.svg";